import { DirectionalHint, Dropdown, IDropdownOption, IDropdownProps, Label, Stack, TooltipHost } from "@fluentui/react";
import React, { useContext } from "react";
import { Conversation } from "../../api";
import { AppStateContext } from "../../state/AppProvider";


interface ChangeGptModeDropdownProps extends IDropdownProps {
  onChange: (event: React.FormEvent<HTMLDivElement> | null, option?: IDropdownOption, index?: number) => void;
  disabled: boolean;
  isRAGSelected: boolean | undefined;
  currentChat: Conversation |  null | undefined;
}

// デフォルトはroutes.pyのget_group_default()で指定するように修正
export const ChangeGptModeDropdown: React.FC<ChangeGptModeDropdownProps> =  ({onChange, disabled, isRAGSelected, currentChat}) => {
  const appStateContext = useContext(AppStateContext);
  const modifiedOptions: IDropdownOption[] = appStateContext?.state.availableModels ? [
    ...Array.from(appStateContext.state.availableModels.entries()).map(option => ({
      key: option[0],
      text: option[1].name,
    }))
  ] : []

  const handleDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
    onChange(event, option);
  };
  

  const onRenderOption = (option?: IDropdownOption): JSX.Element | null => {
    if (!option) return null;
    const model_info = appStateContext?.state.availableModels.get(String(option.key))
    
    return (
      <div style={{
        backgroundColor: model_info?.is_free ? 'inherit' : '#fdecee',
        width: "100%",
        padding: "5px 5px"
      }}>
        <span>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element | null => {
    if (!options || options.length === 0) return null;
    const option = options[0];
    const model_info = appStateContext?.state.availableModels.get(String(option.key))
    return (
      <div style={{
        backgroundColor: model_info?.is_free ? 'inherit' : '#fdecee',
        width: "100%",
        padding: "0px 5px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}>
        {option.text}
      </div>
    );
  };

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
      <TooltipHost content="背景が薄赤色のモデルは課金が発生します" directionalHint={DirectionalHint.bottomCenter}>
        <Label style={{cursor: "pointer"}}>Model</Label>
      </TooltipHost>
      <Dropdown
        options={modifiedOptions}
        selectedKey={appStateContext?.state.selectedGPTModelIndex || ""}
        onChange={handleDropdownChange}
        onRenderOption={onRenderOption}
        onRenderTitle={onRenderTitle}
        styles={{
          dropdown: { width: 180 }, 
          dropdownItem: { padding: 5, height: 'auto' },
        }}
        disabled={disabled}
        data-testid="model-dropdown"
      />
    </Stack>
  );
};
